module.exports = __webpack_public_path__ + "img/公版.4ea15663.svg";